import get from 'lodash/get'
import { connect } from 'react-redux'

import MapView from './MapView'
import marker from '@img/marker.svg'
import markerSelected from '@img/markerSelected.svg'


export default connect((_, props) => ({
  locations: [{
    ...get(props, 'school.static_content.location', {}),
    rating: `${get(props, 'school.static_content.rating.overall', 0)} / 5`,
    name: get(props, 'school.name'),
  }],
  infoWindowContent: '<h2><%= name %></h2><h3><%= rating %></h3>',
  markerIcon: marker,
  markerIconSelected: markerSelected,
}))(MapView)
